import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=5e71700d&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=5e71700d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e71700d"]])

export default __exports__